
























































































import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import {SearchResult} from '#/Search';

export default Vue.extend({
  name: 'SearchResult',

  data: () => ({
    halfExceeded: false,
    scrollHeight: null,
    specifyDisplay: false,
  }),

  computed: {
    ...mapGetters([
      'pageNumber',
      'searchOptions',
      'urlNextPage',
    ]),
    hasSuggests(): boolean {
      return this.searchOptions.suggests.length !== 0;
    },
    hasToManyResults(): boolean {
      return this.searchOptions.results.count > process.env.VUE_APP_PAGINATION_LIMIT || this.searchOptions.isSpecify;
    },
    noAdvert(): boolean {
      return this.searchOptions !== undefined
          ? this.searchOptions.results.adverts.length === 0
          : false;
    },
    middlePage(): number {
      const divisor = this.pageNumber * 2;
      return this.scrollHeight ? Math.round(this.scrollHeight * (divisor - 1) / divisor) : 0;
    },
  },
  created() {
    this.updatePageTitle(this.$t('advert.search.resultTitle'));

    if (Object.entries(this.$route.query).length) {
      this.saveSearchTerm(this.$route.query.q);
    } else {
      this.$router.push({name: 'AdvertList'});
    }
  },
  methods: {
    ...mapActions([
      'loadSearchResult',
      'saveSearchTerm',
      'updatePageTitle',
      'changeSearchFieldStatus',
    ]),
    displayContent(advert: SearchResult) {
      const firstHighlightedContent = advert.content[0].replace(/<[^>]*>?/gm, '');
      const notStart = advert.sourceContent.indexOf(firstHighlightedContent);

      const lastHighlightedContent = advert.content[advert.content.length - 1].replace(/<[^>]*>?/gm, '');
      const notEnd = (
          advert.sourceContent.indexOf(lastHighlightedContent) + lastHighlightedContent.length
      ) < (advert.sourceContent.length - 1);
      return (notStart ? '"...' : '"') + advert.content.join('...') + (notEnd ? '..."' : '"');
    },
    humanDate(date: Date) {
      return `Publié le ${date.toLocaleDateString()}`;
    },
    onScroll(event: UIEvent) {
      // @ts-ignore
      const {scrollTop, clientHeight, scrollHeight} = event.target;

      if (scrollHeight !== this.scrollHeight) this.scrollHeight = scrollHeight;

      if ((scrollTop + clientHeight) > (this.middlePage) && !this.halfExceeded) {
        this.halfExceeded = true;
        this.loadSearchResult({
          searchTerms: null,
          actualPath: this.$route.name,
          loadNextPage: true,
        })
            .then(() => {
              this.halfExceeded = false;
            });
      }
    },
    onSpecifySearch(facetType: string, facetValue: string) {
      this.loadSearchResult({
        searchTerms: null,
        actualPath: this.$route.name,
        loadNextPage: false,
        facetTerms: {
          type: facetType,
          value: facetValue,
        },
      });
    },
    onSuggestClick(newSearchTerm: string) {
      this.$router.push({name: 'SearchResult', query: {q: newSearchTerm}})
          .then(response => {
            this.loadSearchResult({
              searchTerms: response.query.q,
              actualPath: this.$route.name,
              loadNextPage: false,
            });
          })
          .catch(() => {
            this.changeSearchFieldStatus(false);
          });
    },
  },
});
